import { render, staticRenderFns } from "./Ayuda.vue?vue&type=template&id=32f5a02c"
import script from "./Ayuda.vue?vue&type=script&lang=js"
export * from "./Ayuda.vue?vue&type=script&lang=js"
import style0 from "./Ayuda.vue?vue&type=style&index=0&id=32f5a02c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports